var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-ng-c3285680512": "",
    width: "5.33vw",
    height: "5.33vw",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      marginBottom: ".5vw"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "_ngcontent-ng-c3285680512": "",
    id: "icon-set",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    "_ngcontent-ng-c3285680512": "",
    id: "images/h5/icon-set/index-theme-icon",
    transform: "translate(-88.000000, -211.000000)",
    fillRule: "nonzero",
    fill: "#f2ab00"
  }, /*#__PURE__*/React.createElement("g", {
    "_ngcontent-ng-c3285680512": "",
    id: "header-forum-icon",
    transform: "translate(88.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    "_ngcontent-ng-c3285680512": "",
    d: "M18.9,16.5 L15.2,14.3 L8.1,14.3 C7,14.3 5.9,13.3 5.9,12.3 L5.9,11.5 L15.9,11.5 C16.8,11.5 16.9,10.6 16.9,10.4 L16.9,4.7 L17.9,4.7 C19,4.7 19.6,5.4 19.6,6.5 L19.6,12.4 C19.6,13.4 19.1,14.1 18.4,14.3 L18.9,16.5 Z M7,12.6 C7.2,13 7.6,13.3 8.1,13.3 L15.5,13.3 L17.4,14.4 L17.1,13.3 L17.8,13.3 C18.5,13.3 18.5,12.5 18.5,12.3 L18.5,6.4 C18.5,5.7 18.1,5.6 17.8,5.6 L17.8,10.4 C17.8,11.6 17,12.5 15.8,12.5 L7,12.5 L7,12.6 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-ng-c3285680512": "",
    d: "M0.9,13.6 L1.7,10.7 C0.8,10.4 0,9.8 0,8.9 L0,2.2 C0,1 1.4,0 2.6,0 L13.6,0 C14.8,0 16,1.1 16,2.2 L16,8.9 C16,10 15,10.8 13.6,10.8 L5.6,10.8 L0.9,13.6 Z M2.5,1 C1.7,1 0.9,1.7 0.9,2.2 L0.9,8.9 C0.9,9.3 1.6,9.7 2.3,9.8 L2.9,9.9 L2.5,11.5 L5.4,9.8 L13.6,9.8 C14.3,9.8 15,9.4 15,8.9 L15,2.2 C15,1.7 14.4,1 13.6,1 L2.5,1 Z M11.6,6.6 C10.8,6.6 10.1,5.9 10.1,5.1 C10.1,4.3 10.8,3.6 11.6,3.6 C12.4,3.6 13.1,4.3 13.1,5.1 C13.1,5.9 12.5,6.6 11.6,6.6 Z M11.6,4.7 C11.3,4.7 11.1,4.9 11.1,5.2 C11.1,5.5 11.3,5.7 11.6,5.7 C11.9,5.7 12.1,5.5 12.1,5.2 C12.1,4.9 11.9,4.7 11.6,4.7 Z M7.9,6.6 C7.1,6.6 6.4,5.9 6.4,5.1 C6.4,4.3 7.1,3.6 7.9,3.6 C8.7,3.6 9.4,4.3 9.4,5.1 C9.4,5.9 8.7,6.6 7.9,6.6 Z M7.9,4.7 C7.6,4.7 7.4,4.9 7.4,5.2 C7.4,5.5 7.6,5.7 7.9,5.7 C8.2,5.7 8.4,5.5 8.4,5.2 C8.4,4.9 8.2,4.7 7.9,4.7 Z M4.2,6.6 C3.4,6.6 2.7,5.9 2.7,5.1 C2.7,4.3 3.4,3.6 4.2,3.6 C5,3.6 5.7,4.3 5.7,5.1 C5.7,5.9 5,6.6 4.2,6.6 Z M4.2,4.7 C3.9,4.7 3.7,4.9 3.7,5.2 C3.7,5.5 3.9,5.7 4.2,5.7 C4.5,5.7 4.7,5.5 4.7,5.2 C4.7,4.9 4.5,4.7 4.2,4.7 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.cea26fbeae90e784a4768ad86a359d83.svg";
export { ForwardRef as ReactComponent };